import * as React from 'react';

import {LockRegularIcon} from 'shells/icon/svg/lock-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {VirtualMeetingIcon} from 'shells/icon/svg/virtual-meeting-icon';
import {Divider} from 'shells/layout/divider';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

import type {GetActivities_activities as Activity} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {trackLoggingFlowInitiated} from '../../external-meetings/tables/helpers';

import {TimeSection, Participants} from '.';

import styles from './activities-section.module.css';

type Props = {
    activity: Activity;
};

export function ActivityItem({activity}: Props) {
    const itemRef = React.useRef(null);
    const [isHovered, setIsHovered] = React.useState(false);

    const [width, setWidth] = React.useState(0);
    const [newWidth] = useResizeObserver(itemRef.current);

    React.useEffect(() => {
        if (typeof newWidth === 'number') {
            setWidth(newWidth);
        }
    }, [newWidth]);

    const handleClick = () => {
        if (activity.showTranscribeLoggingFlow && activity.externalMeetingServiceType) {
            trackLoggingFlowInitiated(activity.externalMeetingServiceType, 'entity-page');
        }

        appHistory.replace({
            ...appHistory.location,
            hash: `/${activity.id}`,
            state: {modal: true},
        });
    };

    return (
        <>
            <Link
                // @ts-expect-error
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleClick}
                preventUnderline={true}
                tabIndex={0}
            >
                <div ref={itemRef} key={activity.id} className='flex gap-8 align-center px-4 my-4'>
                    <TimeSection startTime={activity.startTime} endTime={activity.endTime} />
                    <div className={styles['activity-name']}>
                        {activity.isPrivate && NutClientConfig.hasActivitySyncContactCreationFF && (
                            <span data-tip='This activity is private' className='flex align-center'>
                                <LockRegularIcon size={14} wrapWithDiv={false} />
                            </span>
                        )}
                        <Body
                            truncate={{type: 'inline'}}
                            title={activity.name}
                            underline={Boolean(isHovered)}
                        >
                            {activity.name}
                        </Body>
                        {activity.showTranscribeLoggingFlow && (
                            <VirtualMeetingIcon size={14} wrapWithDiv={false} />
                        )}
                    </div>
                    <Participants activity={activity} width={width} />
                </div>
                <Divider variant='line--horizontal' />
            </Link>
        </>
    );
}
